import React from 'react';
import { CopyButton, createXComponent } from '@deephaven/components';
import "./WidgetPanelTooltip.css";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function WidgetPanelTooltip(props) {
  var children = props.children,
    descriptor = props.descriptor;
  var name = descriptor.name,
    type = descriptor.type,
    description = descriptor.description,
    displayName = descriptor.displayName;

  // Convert PascalCase to Title Case
  // ex. PartitionedTable -> Partitioned Table
  var formattedType = type.replace(/([a-z])([A-Z])/g, '$1 $2');
  return /*#__PURE__*/_jsxs("div", {
    className: "tab-tooltip-grid-container",
    children: [/*#__PURE__*/_jsxs("span", {
      className: "tab-tooltip-title",
      children: [formattedType, " Name"]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tab-tooltip-name-wrapper",
      children: [/*#__PURE__*/_jsx("span", {
        className: "tab-tooltip-name",
        children: name
      }), /*#__PURE__*/_jsx(CopyButton, {
        UNSAFE_className: "tab-tooltip-copy",
        tooltip: "Copy name",
        copy: name,
        isQuiet: true
      })]
    }), name !== displayName && Boolean(displayName) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "tab-tooltip-title",
        children: "Display Name"
      }), /*#__PURE__*/_jsx("span", {
        className: "tab-tooltip-name",
        children: displayName
      })]
    }), Boolean(description) && /*#__PURE__*/_jsx("div", {
      className: "tab-tooltip-description",
      children: description
    }), children]
  });
}
var XWidgetPanelTooltip = createXComponent(WidgetPanelTooltip);
export default XWidgetPanelTooltip;
//# sourceMappingURL=WidgetPanelTooltip.js.map